import { render, staticRenderFns } from "./CheckSmall.vue?vue&type=template&id=400956ab"
import script from "./CheckSmall.vue?vue&type=script&lang=js"
export * from "./CheckSmall.vue?vue&type=script&lang=js"
import style0 from "./CheckSmall.vue?vue&type=style&index=0&id=400956ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports